function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.05 0H1.95C.87 0 0 .87 0 1.95v16.1C0 19.13.87 20 1.95 20h16.1c1.08 0 1.95-.87 1.95-1.95V1.95C20 .87 19.13 0 18.05 0z",
  fill: "url(#paint0_linear_462_219)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_462_219",
  x1: "10",
  y1: "0",
  x2: "10",
  y2: "20",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EE7B2E"
})))), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "16",
  fill: "none",
  x: "5",
  y: "2.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.67 12.03L.03 8.25a.02.02 0 00-.03.02v6.8a.44.44 0 00.69.35l4.98-3.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 6.75L0 8.24l5.67 3.79L8 10.44l-5.5-3.7z",
  fill: "#FCE2C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.06 7.64L.68.58A.44.44 0 000 .94v4.15a.02.02 0 000 .01l8 5.34h.01l3.05-2.08a.44.44 0 000-.72z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  x: "10",
  y: "10"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "20",
  height: "20",
  rx: "2.5",
  fill: "url(#paint0_linear_462_224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.65 2.38a.3.3 0 01.23-.09h9.27a.3.3 0 01.23.1c.05.06.08.13.08.2a.3.3 0 01-.1.22l-2.73 2.51a.31.31 0 01-.21.1H3.75l2.9-3.04M6.84 14.38a.3.3 0 00-.2.08l-2.8 2.52a.31.31 0 00-.09.21c0 .08.03.15.08.21.06.06.14.1.23.1h9.27a.3.3 0 00.21-.1l2.92-3.02H6.84zM3.75 8.33h9.6a.3.3 0 01.2.1l2.9 3.03H6.87a.3.3 0 01-.2-.1L3.74 8.34z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".74",
  fill: "#fff",
  d: "M13.33 11.46h3.13v2.92h-3.13zM3.75 5.42h3.13v2.92H3.75z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_462_224",
  x1: "10",
  y1: "0",
  x2: "10",
  y2: "20",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68B0DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#468CC3"
}))))));